export const RESET_AVAILABILITY = "RESET_AVAILABILITY";
export const RESET_AVAILABILITIES = "RESET_AVAILABILITIES";
export const RESET_ERROR = "AVAILABILITY_RESET_ERROR";

export const API_ERROR = "AVAILABILITY_API_ERROR";
export const API_ERROR_CRUD = "AVAILABILITY_API_ERROR_CRUD";

export const GET_AVAILABILITIES = "GET_AVAILABILITIES";
export const SET_AVAILABILITIES = "SET_AVAILABILITIES";

export const CREATE_AVAILABILITY = "CREATE_AVAILABILITY";
export const CREATED_AVAILABILITY = "CREATED_AVAILABILITY";

export const GET_AVAILABILITY = "GET_AVAILABILITY";
export const SET_AVAILABILITY = "SET_AVAILABILITY";

export const EDIT_AVAILABILITY = "EDIT_AVAILABILITY";
export const EDIT_AVAILABILITY_SUCCESS = "EDIT_AVAILABILITY_SUCCESS";

export const DELETE_AVAILABILITY = "DELETE_AVAILABILITY";
export const DELETE_AVAILABILITY_SUCCESS = "DELETE_AVAILABILITY_SUCCESS";

export const UPDATE_AVAILABILITY = "UPDATE_AVAILABILITY";
export const UPDATE_AVAILABILITY_SUCCESS = "UPDATE_AVAILABILITY_SUCCESS";

export const UPDATE_AVAILABILITY_AGENT = "UPDATE_AVAILABILITY_AGENT";
export const UPDATE_AVAILABILITY_AGENT_SUCCESS = "UPDATE_AVAILABILITY_AGENT_SUCCESS";

export const UPDATE_AVAILABILITY_SIGNALR = "UPDATE_AVAILABILITY_SIGNALR";
export const UPDATE_AVAILABILITY_SIGNALR_SUCCESS = "UPDATE_AVAILABILITY_SIGNALR_SUCCESS";

export const RESET_UPDATE_AGENT = "RESET_UPDATE_AGENT";

export const REVALIDATE_AVAILABILITY = "REVALIDATE_AVAILABILITY";